import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { AuthService } from '@services';

export const isLoggedInGuard: CanActivateFn = () => {
  return guard(!!inject(AuthService).user());
};

export const isNotLoggedInGuard: CanActivateFn = () => {
  return guard(!inject(AuthService).user());
};

export const isAdminGuard: CanActivateFn = () => {
  return guard(inject(AuthService).user()?.accessLevel === 'admin');
};

export const hasTokenParamGuard: CanMatchFn = (_, segments) => {
  return segments.length === 2 && segments[1].path.length > 0;
};

function guard(condition: boolean): boolean {
  if (!condition) {
    inject(Router).navigate(['404'], { skipLocationChange: true });
  }

  return condition;
}
